import { render, staticRenderFns } from "./SettingsTaxes.vue?vue&type=template&id=1fde950c&"
import script from "./SettingsTaxes.vue?vue&type=script&lang=js&"
export * from "./SettingsTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports